import React from "react";
import LegalPage from "../components/LegalPage";
import { MINISTRY_NAME, MINISTRY_SITE_URL } from "../config";

function PrivacyPolicy() {
    return (
        <LegalPage
            title="Privacy Policy"
            intro={`How ${MINISTRY_NAME} looks after the details you give on this portal.`}
            other={{ to: "/terms-and-conditions", label: "Terms and Conditions" }}
        >
            {/* The text of the policy goes here. */}
            <div className="cf-legal-short">
                <h2>This page is being prepared</h2>
                <p>
                    The privacy policy for the CFCM Portal has not been published yet. If you have a
                    question about your details in the meantime, please reach the ministry through{" "}
                    <a href={MINISTRY_SITE_URL} target="_blank" rel="noopener noreferrer">cfcm.co.ke</a>.
                </p>
            </div>
        </LegalPage>
    );
}

export default PrivacyPolicy;
